<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden relative">
  <button
    type="button"
    class="p-link absolute top-0 right-0 m-4 flex align-items-center gap-2 text-600"
    (click)="languageService.toggle()"
    [attr.aria-label]="(languageService.current() === 'fr' ? 'topbar.switchToEnglish' : 'topbar.switchToFrench') | translate"
    [title]="(languageService.current() === 'fr' ? 'topbar.switchToEnglish' : 'topbar.switchToFrench') | translate">
    <i class="pi pi-globe"></i>
    <span class="uppercase font-medium">{{ languageService.current() }}</span>
  </button>
  <div class="flex flex-column align-items-center justify-content-center">
    <img src="assets/layout/images/logo-smatchy.png"
         alt="{{ 'login.logoAlt' | translate }}" class="mb-5 w-6rem flex-shrink-0 login-logo-mark">
    <div
      style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%);">
      <form class="w-full surface-card py-8 px-5 sm:px-8" style="border-radius:53px" [formGroup]="signInForm">
        <div class="text-center mb-5">
          <h1 class="text-900 text-3xl mb-3">{{ 'login.title' | translate }}</h1>
          <span class="text-600 font-medium">{{ 'login.subtitle' | translate }}</span>
        </div>

        <div>
          <label for="email1" class="block text-900 text-xl font-medium mb-2">{{ 'login.email' | translate }}</label>
          <input id="email1" type="text" placeholder="{{ 'login.emailPlaceholder' | translate }}" pInputText class="w-full mb-5"
                 formControlName="email"
                 style="padding:1rem">

          <label for="password1" class="block text-900 font-medium text-xl mb-2">{{ 'login.password' | translate }}</label>
          <input id="password1" type="password" placeholder="{{ 'login.passwordPlaceholder' | translate }}" pInputText class="w-full mb-5"
                 formControlName="password"
                 style="padding:1rem">


          <button pButton pRipple [label]="'login.submit' | translate" class="w-full p-3 text-xl" (click)="loginEmailPwd()"
                  [disabled]="!signInForm.valid"></button>


          <div class="text-center">
            <p-button label="" [text]="true" [raised]="true" [rounded]="true" (click)="signInGoogle()">
              <img src="assets/google.svg"
                   alt="{{ 'login.googleAlt' | translate }}">
            </p-button>
          </div>

        </div>
      </form>
    </div>
  </div>
</div>
